import {Main} from 'src/Layouts';
import {Drupal, Graphql, YouInvest} from 'src/Api';
import {InvestWithAjBell, Disclaimer} from 'src/Components/Molecules/Card';
import {SideNavigation} from 'src/Components/Molecules/Navigation';
import {InstrumentMain, InstrumentInfoBoxes} from 'src/Components/Organisms';
import {DirectorDealsSection} from './Components/DirectorDealsSection';
import {getTitle, sendCacheHeaders} from 'src/Utils';
import * as Sentry from '@sentry/nextjs';

export default function DirectorDeals({instrumentData}) {
    const getBreadCrumb = () => {
		if (instrumentData) {
			return `${instrumentData.quote.nameShort} (${instrumentData.quote.marketCode}) - Director deals`;
		}
	}

    return <Main title={getTitle(instrumentData, 'Director deals')} nav={instrumentData.nav} breadcrumb={getBreadCrumb()} marketCode={instrumentData.quote.marketCode}>
        <div className="ajb-grid-row padding-bottom-20">
            <div className="ajb-col-2 ajb-col-8-breakpoint padding-top-20 padding-bottom-0-sm">
                <SideNavigation  {...instrumentData} />
                <InvestWithAjBell />
            </div>
            <div className="ajb-col-10 ajb-col-8-breakpoint main-content-wrapper white-bg margin-top-20 padding-20 padding-10-sm">
                <InstrumentMain {...instrumentData} />
                <InstrumentInfoBoxes {...instrumentData} />
                <DirectorDealsSection {...instrumentData} />
                <Disclaimer />
            </div>
        </div>
    </Main>
}
  
export async function getServerSideProps(context) {

    try {
        const {marketCode} = context.query;
        const pageData = await YouInvest.getBasicPageData(marketCode);

        const query = `query pageData(
                $identifier: String!
                $year1: Float!
                $year2: Float!
            ) {
            dd1: directorDeals(identifier: $identifier, year: $year1) {
                name
                officerTitle	
                transactionDate
                transactionAmount
                transactionPrice
                transactionValue
                transactionADCode
                filingDate
                transactionType
                currency      
            }
            dd2: directorDeals(identifier: $identifier, year: $year2) {
                name
                officerTitle	
                transactionDate
                transactionAmount
                transactionPrice
                transactionValue
                transactionADCode
                filingDate
                transactionType
                currency   
            }
        }`;

        const date = new Date();
        
        // Merge the data
        const instrumentData = {...pageData, ...(await Graphql.fetch(query, {
            identifier: marketCode,
            year1: date.getFullYear() - 1,
            year2: date.getFullYear()
        }))};        
        
        const data = instrumentData.dd1.concat(instrumentData.dd2);

        data.sort(function(a,b){		
            return new Date(b.filingDate) - new Date(a.filingDate);
        });

        instrumentData.directorDeals = data;

        sendCacheHeaders(context, pageData);

        return { props: { instrumentData } }

    } catch (e) {
        Sentry.captureException(e);
        return {
            notFound: true
        }
    }
}